import React, { Component } from 'react'
import { DEFAULT_SHIP_TYPE } from '../../../configuration/filters'

class EQuoteSearchFiltersFullFormShip extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      ships,
      currentBrand,
      voyageType,
      currentShip,
      handleSelectShip
    } = this.props
    const renderShips = []

    if (!ships) return

    // Filter out retired ships
    let activeShips = ships.filter(ships => !ships.is_retired)

    // BRAND filter
    if (currentBrand) {
      activeShips = activeShips.filter(
        ship => currentBrand.indexOf(ship.brand_code) > -1
      )
    }

    // CRUISE_TYPE filter
    if (voyageType) {
      activeShips = activeShips.filter(
        ship => voyageType.indexOf(ship.voyageType) > -1
      )
    } else {
      activeShips = activeShips.filter(
        ship => ship.voyageType === DEFAULT_SHIP_TYPE
      )
    }

    // Construct select options
    for (const ship in activeShips) {
      renderShips.push(
        <option
          key={activeShips[ship].ship_code + activeShips[ship].name}
          value={activeShips[ship].ship_code}
        >
          {activeShips[ship].name}
        </option>
      )
    }

    return (
      <div className="equote__search-filters-form-field-input u-custom-select fixed-width-250">
        <select
          name="ship"
          onChange={e =>
            e.target.value === ''
              ? handleSelectShip()
              : handleSelectShip(e.target.value)
          }
          value={currentShip}
          tabIndex={0}
          aria-labelledby="shipToggleLabel"
        >
          <option value="">All Ships</option>
          {renderShips}
        </select>
        <span className="u-custom-select__arrow" />
      </div>
    )
  }
}

export default EQuoteSearchFiltersFullFormShip
